import StoresPage from "../components/pages/stores/StoresPage";
import CreateStorePage from "../components/pages/stores/CreateStorePage";
import POSConfig from "../components/pages/stores/POSConfigPage";
import POSStore from "../components/pages/stores/POSStorePage";


const routes = [
    {
        path: "/stores",
        element: <StoresPage />
    },
    {
        path: "/stores/create",
        element: <CreateStorePage />
    },
    {
        path: "/stores/edit/:storeID",
        element: <CreateStorePage />
    },
    {
        path: "/stores/pos",
        element: <POSConfig />
    },
    {
        path: "/stores/pos-store",
        element: <POSStore />
    }
];


export default routes;
